import { PaymentState, ReviewState } from '@typings/insurance';
import React from 'react';
import { FormattedMessage } from 'react-intl';

enum COLOR {
  INK_NORMAL = 'fill-ink-500',
  GREEN = 'fill-green-500',
  DARK_YELLOW = 'fill-yellow-700',
  DARK_RED = 'fill-red-900',
}

const STATUS_COLOR: Record<ReviewState | PaymentState, COLOR> = {
  not_filed: COLOR.INK_NORMAL,
  submitted: COLOR.DARK_YELLOW,
  documents_requested: COLOR.DARK_YELLOW,
  pending_review: COLOR.DARK_YELLOW,
  pending_with_courier: COLOR.DARK_YELLOW,
  denied: COLOR.DARK_RED,
  approved: COLOR.GREEN,
  payment_info_requested: COLOR.DARK_YELLOW,
  processing_payment: COLOR.DARK_YELLOW,
  paid: COLOR.GREEN,
  closed: COLOR.DARK_RED,
};

export default function ClaimState({ state }: { state: ReviewState | PaymentState }) {
  return (
    <div className="flex items-center justify-center">
      <svg
        height="12"
        width="16"
        className={STATUS_COLOR[state] || COLOR.INK_NORMAL}
        aria-label={`Claim state: ${state}`}
      >
        <circle cx="6" cy="6" r="6" stroke="none" />
      </svg>
      <strong className="text-ink-900">
        <FormattedMessage id={`insurance-claim.claim-states.${state}`} />
      </strong>
    </div>
  );
}
